import { FC, HTMLAttributes } from "react";

interface MobileMenuHeaderLabelProps extends HTMLAttributes<HTMLElement> {
  label: string;
}

const MobileMenuHeaderLabel: FC<MobileMenuHeaderLabelProps> = ({ label = "" }) => {
  return (
    <div className="mt-[-1px] flex w-screen justify-between border-y-[1px] border-fog-20 bg-fog-10 px-6 py-4 text-sm font-semibold text-fog-60">
      {label}
    </div>
  );
};

export { MobileMenuHeaderLabel };
